import React from 'react';
import classnames from 'classnames';
import * as styles from './Tab.scss';

const Tab = props => (
  <button
    className={classnames(
      { [styles.fcIsTabActive]: props.isActive },
      styles.fcTab,
    )}
    onClick={event => props.onClick(props.id, event)}
  >
    {props.children}
  </button>
);

export default Tab;
